import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export interface Vendor {
  id: number;
  companyName: string;
  vendorCategory: string | null;
  contactPerson: string | null;
  country: string | null;
  state: string | null;
  city: string | null;
  address: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  productsSupplied: string | null;
  productCategory: string | null;
  manufacturerDistributor: string | null;
  brandsSupplied: string | null;
  moq: string | null;
  unitCasePack: string | null;
  pricePerUnit: number | null;
  paymentTerms: string | null;
  customLogoBranding: 'Yes' | 'No';
  lastOrderDate: string | null;
  lastPurchaseAmount: number | null;
  status: 'Active' | 'Inactive' | 'Pending';
  notes: string | null;
  userId: number;
  createdDate: number;
}

export type CreateVendorRequest = Omit<Vendor, 'id' | 'userId' | 'createdDate'>;

export interface PaginatedVendorsResponse {
  data: Vendor[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const vendorsApi = {
  getAll: (params: { page?: number; limit?: number; search?: string; status?: string }, token: string): Promise<PaginatedVendorsResponse> => {
    const q = new URLSearchParams();
    if (params.page) q.append('page', params.page.toString());
    if (params.limit) q.append('limit', params.limit.toString());
    if (params.search) q.append('search', params.search);
    if (params.status) q.append('status', params.status);
    return apiRequest<PaginatedVendorsResponse>(
      `${buildApiUrl(API_CONFIG.ENDPOINTS.VENDORS.BASE)}?${q}`,
      { method: 'GET', headers: getAuthHeaders(token) }
    );
  },

  create: (data: Partial<CreateVendorRequest>, token: string): Promise<Vendor> =>
    apiRequest<Vendor>(buildApiUrl(API_CONFIG.ENDPOINTS.VENDORS.BASE), {
      method: 'POST',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  update: (id: number, data: Partial<CreateVendorRequest>, token: string): Promise<Vendor> =>
    apiRequest<Vendor>(buildApiUrl(API_CONFIG.ENDPOINTS.VENDORS.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  remove: (id: number, token: string): Promise<void> =>
    apiRequest<void>(buildApiUrl(API_CONFIG.ENDPOINTS.VENDORS.BY_ID(id)), {
      method: 'DELETE',
      headers: getAuthHeaders(token),
    }),
};
